/* jshint -W058 */
/*globals google*/
(function () {
    'use strict';
    angular
        .module('invesfleet')
        .controller('MapController', MapController);

    MapController.$inject = [
        '$rootScope',
        '$timeout',
        '$scope',
        'fleet',
        'userService',
        'scopes',
        'NgMap',
        '$q',
        'endPoints',
        'preferences',
        '$filter',
        '$state',
        'chat',
        '$stateParams',
        '$location',
        'common'
    ];

    /* jshint maxstatements:false */
    /* jshint maxparams:false */
    function MapController(
        $rootScope,
        $timeout,
        $scope,
        fleet,
        userService,
        scopes,
        NgMap,
        $q,
        endPoints,
        preferences,
        $filter,
        $state,
        chat,
        $stateParams,
        $location,
        common
    ) {

        /* PRIVATE VARIABLES */
        var MIN_ZOOM = 16;
        var TIME_TO_DISCONNECTED = 2 * 60;


        /* PUBLIC VARIABLES */
        var vm = this;
        vm.userService = userService;
        vm.MAX_TIME_LAST_POS = 300; //5 min
        vm.fleet = fleet;
        vm.chat = chat;
        vm.layers = { //Capas
            vehicles: true,
            orders: true,
            clients: false,
            delegations: false,
            workshops: false,
            poi: false
        };
        vm.selectedVehicle = null;
        vm.selectedOrden = null;
        vm.tabs = {
            show: false,
            selected: 1,
            toggle: function () {
                this.changeShow(!this.show);
            },
            set: function (showVal) {
                this.changeShow(showVal);
                $timeout(function () { resizeMap(); }, 0);
            },
            select: function (tab) {
                this.selected = tab ? tab : -1;
                this.changeShow(true);
            },
            isSelected: function (tab) {
                return this.selected === tab;
            },
            changeShow: function (value) {
                this.show = value;
                if (this.show) {
                    document.querySelector('#main-container').classList.add("showPanel");
                }
                else {
                    document.querySelector('#main-container').classList.remove("showPanel");
                }
            }
        };

        vm.googleApiURL = endPoints.GOOGLE_MAPS_API_URL;
        vm.prefs = preferences.prefs;
        vm.seguimiento = {
            active: false,
            vehicles: {}
        };

        vm.logos = {
            0: 'content/img/aseguradoras/asitur/asitur-imagotipo.png',
            1: 'content/img/aseguradoras/racc/racc-imagotipo.png',
            2: 'content/img/aseguradoras/mapfre/mapfre-imagotipo.png',
            3: 'content/img/aseguradoras/europ/europ-imagotipo.png',
            4: 'content/img/aseguradoras/mm/mm-imagotipo.png',
            5: 'content/img/aseguradoras/race/race-imagotipo.png',
            6: 'content/img/aseguradoras/allianz/allianz-imagotipo.png',
            7: 'content/img/aseguradoras/pelayo/pelayo-imagotipo.png',
            8: 'content/img/aseguradoras/ld/ld-imagotipo.png',
        };

        vm.estadosOrden = {
            null: 'NU', /* Nueva */
            0: 'PA', /* Pte. Asignar */
            1: 'AS', /* Asignado */
            2: 'AC', /* Aceptado */
            3: 'RZ', /* Rechazado */
            4: 'IC', /* Iniciado */
            5: 'LZ', /* Localizado */
            6: 'EN', /* Entregado */
            10: 'FZ', /* Finalizado */
            11: 'OC', /* Ocupado */
            12: 'DC' /* Desconectado */
        };

        vm.rootScope = $rootScope;
        /* PUBLIC FUNCTIONS */
        vm.onMarkerClick = onMarkerClick;
        vm.selectVehicleSideBar = selectVehicleSideBar;
        vm.getSignalIntensity = getSignalIntensity;
        vm.tiempoTranscurrido = tiempoTranscurrido;
        vm.getColorEstadoOrden = getColorEstadoOrden;
        vm.getColorEstadoVehicle = getColorEstadoVehicle;
        vm.iconTypeOrder = iconTypeOrder;
        vm.resetMap = resetMap;
        vm.formatNullable = formatNullable;
        vm.filterOrders = filterOrders;
        vm.getOrderState = getOrderState;
        vm.formatDate = formatDate;
        vm.zoomToIncludeTracked = zoomToIncludeTracked;
        vm.checkBoxStatus = checkBoxStatus;
        vm.trackAll = trackAll;
        vm.trackVehicle = trackVehicle;
        vm.onlineFilter = onlineFilter;
        vm.chatBoxKeyPress = chatBoxKeyPress;
        vm.getColorEstadoOperario = getColorEstadoOperario;
        vm.onClickOrder = onClickOrder;
        vm.goActiveOrder = goActiveOrder;
        vm.goFichaOrdenes = goFichaOrdenes;
        vm.getIconoOrden = getIconoOrden;
        vm.getObservaciones = getObservaciones;
        vm.centerMapOn = centerMapOn;
        vm.vehicleForOrder = vehicleForOrder;


        $(window).on('active-orders-update', function (e, args) {

            if (common.isNullOrUndefined(args.orders) || common.isNullOrUndefined(fleet.activeOrdersList))
				return;

			for (var i = 0; i < args.orders.length; i++) {

				if (args.orders[i].tipo < 2) { //  de tipo 0 -1, debe actualizar solo en activas y mapa
					if (args.orders[i].changed == true) {
						for (var j = 0; j < fleet.activeOrdersList.length; j++) {
							if (fleet.activeOrdersList[j].orderId == args.orders[i].orderId) {
								fleet.activeOrdersList[j] = args.orders[i];
								break; //Stop this loop, we found it!
							}

						}
						break;
					}
					else {
						fleet.activeOrdersList.push(args.orders[i]);
					}
				} else { //  de tipo 2, debe actualizar solo traslados (cabeceras)

				}
            }

            $(window).trigger('active-orders-update-setGridData');

            //Se tendría que hacer lo del digest acá?
            //vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        });

		$(window).on('removed-order', function (e, args) {
            fleet.activeOrdersList.splice(fleet.activeOrdersList.indexOf(x => x.orderId == args), 1);
            $(window).trigger('active-orders-update-setGridData');
            //Se tendría que hacer lo del digest acá?
            //vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        });
		
        /* INITIALIZER */
        (function () {

            var paramVehicle = $stateParams.id;
            vm.selectedOrden = null;
            if (paramVehicle) {
                selectVehicle(paramVehicle);
            }

            vm.fleet.getActiveOrders().then(function (result) {
                vm.fleet.activeOrdersList = result;

            });
            setMapResizers();

            linkWithMain();

            $scope.$on('mapInitialized', function (event, map) {
                setMapZoomCenter();
                var lat = $stateParams.lat, long = $stateParams.long;
                if (lat && long && !paramVehicle) {
                    setMapPosForVehicle({ latitude: lat, longitude: long });
                }
            });

            //userService.loadWithDefaults(defaultConfig) //initialize user options
            //    .then(function(data) {
            //        userConfig = data;
            //});

        })();

        $scope.$on('fleetdata-refreshed', function (event, args) {
            // Refresh reference to selected vehicle
            if (vm.selectedVehicle) { selectVehicle(vm.selectedVehicle.id); }

            //Refresh references to tracked vehicles
            var seg = {};
            for (var key in vm.seguimiento.vehicles) {
                if (vm.seguimiento.vehicles.hasOwnProperty(key) && vm.seguimiento.vehicles[key] && findByFleetId(key)) {
                    seg[key] = true;
                }
            }
            vm.seguimiento.vehicles = seg;

            if (vm.seguimiento.active) { vm.zoomToIncludeTracked(); }
        });


        /* FUNCTION DEFINITIONS */
        function onMarkerClick(event, fleetId) {
            vm.selectedOrden = null;
            vm.seguimiento.active = false;
            selectVehicle(fleetId);
            setMapPosForVehicle(vm.selectedVehicle);
            vm.tabs.set(true);
            if (vm.tabs.selected <= 0) {
                vm.tabs.select(1);
            }
        }

        function onClickOrder(event, orden) {
            vm.selectedOrden = orden;
            vm.selectedVehicle = null;
            setMapPosForVehicle(vm.selectedOrden);
            vm.tabs.set(true);
        }

        function selectVehicleSideBar(fleetId) {
            vm.seguimiento.active = false;
            var vChange = fleetId.toString() !== (vm.selectedVehicle ? vm.selectedVehicle.id : null);
            selectVehicle(fleetId);
            setMapPosForVehicle(vm.selectedVehicle);
            //if (vChange) { vm.tabs.selected = 1; }
            vm.tabs.set(true);
        }

        function getSignalIntensity(numericInput) {
            if (numericInput <= 6) {
                return 'Muy baja';
            } else if (numericInput <= 12) {
                return 'Baja';
            } else if (numericInput <= 18) {
                return 'Normal';
            } else if (numericInput <= 24) {
                return 'Buena';
            } else if (numericInput > 24) {
                return 'Muy Buena';
            } else {
                return '-';
            }
        }

        function tiempoTranscurrido(time) {
            if (!time) {
                return '-';
            }
            var dateNow = Date.NewDate();
            var timeNow = dateNow.getTime();
            var timeLasPos = new Date(time).getTime();
            var differenceTime = Math.floor((timeNow - timeLasPos) / 1000);
            return differenceTime;
        }

        function getColorEstadoOrden(estado) {
            return preferences.prefs.getStateColor(estado) || 'undefined';
        }

        function getColorEstadoVehicle(vehicle) {
            if (!vehicle) { return 'undefined'; }
            if (!vehicle.isConnected) { return preferences.prefs.getStateColor(100); }
            return preferences.prefs.getStateColor(vehicle.operatorStateId) || 'undefined';
        }

        function getColorEstadoOperario(vehicle) {
            if (!vehicle) { return 'undefined'; }
            if (!vehicle.isActive) { return preferences.prefs.getStateColor(100); }
            return preferences.prefs.getStateColor(vehicle.operatorStateId) || 'undefined';
        }

        function iconTypeOrder(data) {
            var typeIcon = '';
            // Icono Stop
            if (!data.gpio2 && data.speed === 0) {
                typeIcon = 'icon-stop';
            }
            // Icono Movimiento
            else if (data.speed > 0) {
                typeIcon = 'icon-move';
            }
            // Icono ralenti
            else if (data.gpio2 && data.speed === 0) {
                typeIcon = 'icon-ralenti';
            }
            // Icono alert
            if (!data.isLocalized) {
                typeIcon = 'icon-alert';
            }

            return typeIcon;
        }

        function getIconoOrden(tipo) {
            return userService.userData.orders.iconoOrden[tipo] || 'undefined';
        }

        function resetMap() {
            vm.selectedVehicle = null;
            vm.selectedOrden = null;
            vm.seguimiento = {
                active: false,
                vehicles: {}
            };
            setMapZoomCenter();
        }

        function formatNullable(text) {
            if (text === null) { return '-'; }
            return text;
        }

        function filterOrders(order) {
            if (!vm.selectedVehicle) { return false; }
            if (!order) { return false; }
            var oCheck = order.operatorId != null &&
                vm.selectedVehicle.idOperator != null &&
                order.operatorId === vm.selectedVehicle.idOperator;
            return oCheck;
        }

        function getOrderState(stateId) {
            //return userConfig.literals? userConfig.literals.estadosOrden[stateId] || '-' : '-';
            return preferences.prefs.getStateDesc(stateId);
        }

        function formatDate(ISODate) {
            var date = new Date(ISODate);
            return date.toLocaleString();
        }

        function onlineFilter(isOnline) {
            return function (item) {
                return item.isActive === isOnline;
            };
        }


        /*
        --------SEGUIMIENTO---------
        Estado inicial: desactivado y ningún vehiculo selectionado para seguimiento.

        Con seguimiento ON:
        - Si no hay ningun vehiculo -> Ajustar mapa para incluir todos los markers (vehiculos y ordenes)

        Al selectionar un vehiculo para seguimiento -> seguimiento se activa
        Al hacer click en un vehiculo seguimiento se desactiva 
        y se centra en el vehiculo seleccionado (sin perder la seleccion de vehiculos para seguimiento)

        */
        function zoomToIncludeTracked() {
            if (!vm.seguimiento.active) { return; }
            var locations = [];
            for (var key in vm.seguimiento.vehicles) {
                if (vm.seguimiento.vehicles.hasOwnProperty(key) && vm.seguimiento.vehicles[key]) {
                    locations.push(findByFleetId(key));
                }
            }

            if (locations.length > 0) {
                var bounds = new google.maps.LatLngBounds();
                var n = addToBounds(bounds, locations);
                if (n === 0) { return; }
                fitToBounds(bounds);
            }
            else { zoomToIncludeMarkers(); }
        }

        function checkBoxStatus(isActive) {

            //entra aquí por una directiva llamada checkbox indeterminated
            //if (!vm.fleet.live) {
            //    console.log('false');
            //    return false;
            //}

            if (!vm.fleet.canContinue) {
                return false;
            }
            var vehicles = $filter('filter')(vm.fleet.mapData.fleet, { isOnline: isActive });
            var last = null;
            for (var i = 0; i < vehicles.length; i++) {
                var isTracked = !!vm.seguimiento.vehicles[vehicles[i].id];
                if (last == null) { last = isTracked ? isTracked : false; }
                else if (last !== isTracked) {
                    return null;
                }
            }
            return last;
        }

        function trackAll(isActive) {
            if (!vm.fleet.live) { return false; }
            var vehicles = $filter('filter')(vm.fleet.mapData.fleet, { isOnline: isActive });
            var ind = vm.checkBoxStatus(isActive) == null;
            for (var i = 0; i < vehicles.length; i++) {
                vm.seguimiento.vehicles[vehicles[i].id] =
                    ind ? true : !vm.seguimiento.vehicles[vehicles[i].id];
            }
            vm.seguimiento.active = true;
            vm.zoomToIncludeTracked();
            $state.go('flota.mapa');
        }

        function trackVehicle() {
            vm.seguimiento.active = true;
            vm.zoomToIncludeTracked();
            $state.go('flota.mapa');
        }

        function chatBoxKeyPress(keyEvent, opId, msg) {
            if (keyEvent.which === 13) {
                vm.chat.sendMessage(opId, msg);
                msg = null;
            }
        }

        function centerMapOn(lat, long) {
            if (lat == null || long == null) { return; }
            var LatLng = new google.maps.LatLng(lat, long);
            if ($scope.map.zoom !== MIN_ZOOM) { //Fix for animations on the map
                $scope.map.setCenter(LatLng);
                $scope.map.setZoom(MIN_ZOOM);
            }
            else { $scope.map.panTo(LatLng); }
        }


        /* PRIVATE FUNCTIONS */
        function linkWithMain() { //Link with main to share scopes for the fleet side bar
            var main = scopes.get('main');
            if (main != null) {
                //if(main.map){ vm.selectedVehicle = main.map.selectedVehicle; }
                vm.main = main;
                vm.main.map = vm;
            }
            scopes.store('map', vm);
        }

        /*function loadCompanyPreferences() {
            if (!preferences.loaded) {
                preferences.getCompanyPrefs();
            }
        }*/

        function setMapResizers() { //Functionality to correctly display the map
            var tab = $rootScope.tabManager.tabs[$rootScope.tabManager.indexOfName('flotaMapa')];
            $rootScope.$watch(function () { return tab.isActive(); }, //TODO: Cambiar watch por evento
                function () {
                    if (tab.isActive()) {

                        $timeout(function () { resizeMap(); }, 0);
                    }
                }
            );
            $scope.$on('detail-resize', function (event, args) {
                if (tab.isActive()) {
                    $timeout(function () { resizeMap(); }, 0);
                }
            });
        }

        function resizeMap() {
            return NgMap.getMap('mapa').then(function (map) {
                //If tab was initialized while closed zoom will be 0 so we need to call 'setMapZoomCenter' again
                if (map.getZoom() <= 2) {
                    $scope.google.maps.event.trigger(map, 'resize');
                    setMapZoomCenter();
                } else if (vm.seguimiento.active) {
                    $scope.google.maps.event.trigger(map, 'resize');
                    vm.zoomToIncludeTracked();
                } else {
                    var center = map.getCenter();
                    $scope.google.maps.event.trigger(map, 'resize');
                    map.setCenter(center);
                }
            });
        }

        var firstCallDone = false;
        function setMapZoomCenter() {
            if (!vm.fleet.live) {
                if (!firstCallDone) {
                    firstCallDone = true;
                    vm.fleet
                        .getMapData()
                        .then(setMapZoomCenter);
                }
                return;
            }
            if (vm.selectedVehicle != null && vm.selectedVehicle.id !== '') {
                setMapPosForVehicle(vm.selectedVehicle);
            } else {
                zoomToIncludeMarkers();
            }
        }

        function setMapPosForVehicle(vehicle) {
            if (!vehicle.latitude || !vehicle.longitude) { return; } //Si no hay localizacion correcta no mover el mapa
            var LatLng = new google.maps.LatLng(vehicle.latitude, vehicle.longitude);
            if ($scope.map.zoom !== MIN_ZOOM) { //Fix for animations on the map
                $scope.map.setCenter(LatLng);
                $scope.map.setZoom(MIN_ZOOM);
            }
            else { $scope.map.panTo(LatLng); }
        }

        function zoomToIncludeMarkers() {
            setTimeout(function () {
                var bounds = new google.maps.LatLngBounds();
                var nLocations = 0;
                //console.log(vm.fleet.mapData); 
                if (vm.layers.vehicles) { nLocations += addToBounds(bounds, vm.fleet.mapData.fleet); }
                if (vm.layers.orders) { nLocations += addToBounds(bounds, vm.fleet.activeOrdersList); }
                if (nLocations === 0) { return; }
                fitToBounds(bounds);
            }, 1000);
        }

        function addToBounds(bounds, locations) {
            if (common.isNullOrUndefined(locations))
                return 0;

            var nLocations = 0;
            locations.forEach(function (location) {
                if (location.latitude && location.longitude) {
                    var latLng = new google.maps.LatLng(location.latitude, location.longitude);
                    bounds.extend(latLng);
                    nLocations++;
                }
            });
            return nLocations;
        }

        function fitToBounds(bounds) {
            $scope.map.fitBounds(bounds);
            if ($scope.map.zoom > MIN_ZOOM) { $scope.map.setZoom(MIN_ZOOM); } //Minimun zoom
        }

        function findByFleetId(fleetId) {
            if (!vm.fleet.live) { return null; }
            var array = vm.fleet.mapData.fleet;
            if (common.isNullOrUndefined(array))
                return null;
            for (var i = 0; i < array.length; i++) {
                if (array[i].id === fleetId.toString()) {
                    return array[i];
                }
            }
            return null;
        }

        function getAddress(lat, long) {
            var geocoder = new google.maps.Geocoder();
            var latlng = new google.maps.LatLng(
                parseFloat(lat),
                parseFloat(long)
            );

            var deferred = $q.defer();
            geocoder.geocode(
                { 'latLng': latlng },
                function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        if (results[0]) {
                            /*jshint camelcase: false */
                            deferred.resolve(results[0].formatted_address); return;
                        }
                    }
                    deferred.reject('Dirección no encontrada');
                }
            );
            return deferred.promise;
        }

        function selectVehicle(id) {
            var v = findByFleetId(id);
            if (vm.selectedVehicle) {
                v.address = vm.selectedVehicle.address;
            }
            vm.selectedVehicle = v;
            vm.selectedOrden = null;

            if (vm.selectedVehicle == null) { return; }

            getAddress(vm.selectedVehicle.latitude, vm.selectedVehicle.longitude).then(
                function (address) { vm.selectedVehicle.address = address; },
                function (result) { vm.selectedVehicle.address = result; });

        }

        function goActiveOrder(orden) {
            onClickOrder(undefined, orden);
        }

        function goFichaOrdenes(order) {
            //var allOrdersOpen = null;
            //if (vm.rootScope.tabManager.indexOfName('ordenes') !== -1) {
            //	allOrdersOpen = true;
            //}
            //$state.go('flota.ordenes.editar', { 'id': order.orderId, 'allOrdersOpen': allOrdersOpen });
            $rootScope.tabManager.goToOrdenes(order.orderId);
        }

        var lastObs = [];
        var lastObsId = null;
        function getObservaciones(json, id) {
            if (lastObsId === id) { return lastObs; }
            lastObsId = id;
            var result = [];
            if (json == null || json === '') {
                result = [];
            } else {
                try { result = JSON.parse(json); }
                catch (e) {
                    result = [{ text: json }];
                }
            }
            lastObs = result;
            return result;
        }

        $scope.$on('heartbeat-pulse', function (event, args) {
            if (vm.selectedVehicle != null && vm.tabs.isSelected(4)) {
                markAsReadForOperator(vm.selectedVehicle.operatorId);
            }
        });

        function markAsReadForOperator(id) {
            var messages = vm.chat.messages;
            if (common.isNullOrUndefined(messages)) {
                return;
            }
            var to = messages.length || 0;
            var ids = [];
            for (var i = 0; i < to; i++) {
                if (messages[i].direction === 'IN' &&
                    messages[i].operatorId === id &&
                    messages[i].readTime === null) {
                    ids.push(messages[i].id);
                }
            }
            if (ids.length > 0) {
                chat.markAsRead(ids);
            }
        }

        function vehicleForOrder(order) {
            if (!order) { return null; }

            return $filter('filter')(vm.fleet.mapData.fleet, { idOperator: order.operatorId })[0];
        }
    }
})();